module.exports = __webpack_public_path__ + "gh.svg?5460b9ab61f03f0609e28b84f2fc9a69";